import React from 'react'

/** Material UI **/
import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  CssBaseline
} from '@mui/material'
import { useLocation } from 'react-router-dom'

/** Components **/
import { NavBar } from './NavBar'
import { useSelector } from 'react-redux'
import { useWindowSize } from '@react-hook/window-size'

/** Utils */
import { mobileBreakpoint } from '../lib/Constants'

/** Styles */
import { mainContainerStyles } from '../styles/classes/CommonClasses'

export const MainContainer = (props) => {
  const location = useLocation()
  const [wWidth] = useWindowSize()
  const isMobile = wWidth <= mobileBreakpoint
  const { classes } = mainContainerStyles()
  const loading = useSelector((state) => state.loading.loading)
  const locationPath = location.pathname

  return (
    <div>
      <CssBaseline />
      <Container
        disableGutters={true}
        maxWidth={false}
        className={classes.scrollContainer}
        style={{
          minWidth: isMobile ? 'unset' : wWidth > 800 ? '800px' : '1440px'
        }}
      >
        <Container disableGutters maxWidth={false} className={classes.container}>
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {locationPath !== '/form-builder' && <NavBar />}
          {locationPath !== '/form-builder' && <Box className={classes.navBarOffset}/>}
          <Box>{props.children}</Box>
        </Container>
      </Container>
    </div>
  )
}
